import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  Container
} from '@mui/material';
import { 
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  Construction as ConstructionIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const ComingSoonPage = ({ 
  title = "Feature Under Development", 
  message = "This feature is not yet implemented. We're working on it and it will be available soon.",
  customBackPath = null,
  customBackText = null 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getBackNavigation = () => {
    const path = location.pathname;

    if (customBackPath) {
      return {
        path: customBackPath,
        text: customBackText || 'Go Back'
      };
    }

    // Always go back to dashboard for reports
    if (path.includes('/reports/')) {
      return { path: '/dashboard', text: 'Go Back to Dashboard' };
    } else if (path.includes('/leads/')) {
      return { path: '/leads', text: 'Go Back to Leads' };
    } else if (path.includes('/calls/')) {
      return { path: '/calls', text: 'Go Back to Calls' };
    } else if (path.includes('/agents/')) {
      return { path: '/agents', text: 'Go Back to Agents' };
    } else if (path.includes('/settings/')) {
      return { path: '/settings', text: 'Go Back to Settings' };
    } else {
      return { path: '/dashboard', text: 'Go Back to Dashboard' };
    }
  };

  const backNavigation = getBackNavigation();

  return (
    <Container maxWidth="sm" sx={{ height: '100vh', overflow: 'auto' }}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          pt: 4
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            maxWidth: 500,
            width: '100%'
          }}
        >
          {/* Icon */}
          <Box sx={{ mb: 3 }}>
            <ConstructionIcon 
              sx={{ fontSize: 80, color: 'warning.main', opacity: 0.8 }} 
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              mb: 2
            }}
          >
            Feature Under Development....
          </Typography>

          {/* Message */}
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mb: 4,
              lineHeight: 1.6,
              fontSize: '1.05rem'
            }}
          >
            {message}
          </Typography>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/dashboard')}
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                  transform: 'translateY(-1px)'
                }
              }}
            >
              Go Back to Dashboard
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ComingSoonPage;
